'use client';

import { type VariantProps, cva } from 'class-variance-authority';
import { cn } from '@medizzconnect/shared';

const badgeVariants = cva(
  [
    'inline-flex items-center gap-1 rounded-full',
    'text-xs font-medium whitespace-nowrap',
  ],
  {
    variants: {
      variant: {
        default: 'bg-bg-subtle text-text-secondary',
        primary: 'bg-primary-50 text-primary-700',
        success: 'bg-success-50 text-success-700',
        warning: 'bg-warning-50 text-warning-700',
        error: 'bg-error-50 text-error-700',
        info: 'bg-blue-50 text-blue-700',
      },
      size: {
        sm: 'px-2 py-0.5 text-[11px]',
        md: 'px-2.5 py-0.5 text-xs',
        lg: 'px-3 py-1 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  },
);

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant, size, className }))} {...props} />
  );
}

export { badgeVariants };
